import type { FaireProductEntity } from "../../entity_types/product";

export const p_sdng7pxeav: FaireProductEntity = {
  token: "p_sdng7pxeav",
  type: "product",
  name: "Enchanted Forest Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b539f0b72b397f1ffa45b68151deae23aca9966017bb14aded4a800c2c630a89.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6b3930fddc7071e04573d64b528ebc746ea065608437901b7f73ee260a257a0.jpeg",
    "https://cdn.faire.com/fastly/ea9b322e83cca5d75be353b5c21808d1a15ef632b62a357da28205785956fc7e.jpeg",
    "https://cdn.faire.com/fastly/15ca25bfaab27e6e3c56199ae3ab718d180aeb622a08af789c8b5d47ffb09c5b.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:26.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
